import { Component, Inject, OnInit } from '@angular/core';
import { BaseCustomDialog } from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { DateTimeHelper, TimePeriodType } from '../../../../helper/date-time.helper';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';
import { AppointmentsHelper } from '../../../../helper/appointments.helper';
import { ID_KEY, UserTokenService } from '../../../../services/user-service/user-token.service';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import { ICompanyContacts, IContact } from '../../../../models/leads/leads.model';
import {
  LeadsMultipleStepByStepService
} from "../../../../services/leads-multiple-step-by-step/leads-multiple-step-by-step.service";
import { ActionHelper } from "../../../../helper/action.helper";
import { PROFILE_DATA_ID } from '../../../../constants/constants';

@Component({
  selector: 'fi-offer-delay-popup',
  templateUrl: './offer-delay-popup.component.html',
  styleUrls: ['./offer-delay-popup.component.scss'],
  standalone: false,
})
export class OfferDelayPopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  selectedTypeId: number;
  readonly dateOptionTypes = DateTimeHelper.datePeriodTypes;

  searchedText = '';
  note = '';
  selectedDate: Date;
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('OFFER_DELAY', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('OFFER_DELAY', true);
  submitting: boolean;
  appointmentExists = false;
  userTokenService: UserTokenService;
  companyContacts: ICompanyContacts[];
  contactToDisplay: IContact;
  inValidNote = false;
  isMany: boolean;
  leads: number[];
  private cancel = false;
  step: number = 0;

  constructor(
    public dialogRef: MatDialogRef<OfferDelayPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: {contactName: string, leadId: number, leadTypeId: number, title: string, leads: number[], isMany: boolean},
    private leadsMultipleStepByStepService: LeadsMultipleStepByStepService,
    private dialog: MatDialog,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
    this.isMany = dialogData?.isMany;
    this.leads = dialogData?.leads;

    if (!this.isMany) {
      this.leadsDataService.getLeadById(this.leadId).subscribe(({ success, data }) => {
        if (success) {
          this.companyContacts = data.CompanyContacts;
          this.contactToDisplay = data.Contact;
        }
      });
    }

    leadsMultipleStepByStepService.listenToCancel().subscribe(data => {
      this.cancel = true;
    })
  }

  onDateSelect(date: Date, time = false): void {
    this.selectedTypeId = null;

    if (!date) {
      this.selectedDate = null;
      return;
    }

    if (!this.selectedDate) {
      this.selectedDate = date;
    } else if (!time) {
      this.selectedDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    } else {
      this.selectedDate.setHours(date.getHours(), date.getMinutes());
    }

    this.selectedDate = new Date(this.selectedDate);

    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  setPeriods($event): void {
    this.selectedTypeId = $event;
    this.selectedDate = DateTimeHelper.getDateAfterPeriod(this.dateOptionTypes.find(item => item.Id === +$event));
    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  onDateOptionSelected(type: TimePeriodType): void {
    this.selectedTypeId = type.Id;
    this.selectedDate = DateTimeHelper.getDateAfterPeriod(type);
    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  ngOnInit(): void {
    setTimeout(() => {
      const userId = Number(sessionStorage.getItem(PROFILE_DATA_ID));
      AppointmentsHelper.getDbAppointments(this.actionDataService, userId);
    }, 1000);
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    if (this.isMany) {
      return this.leads.length > 0 && !!this.selectedDate && !this.submitting && !this.inValidNote;
    }
    return !!this.leadId && !!this.selectedDate && !this.submitting && !this.inValidNote;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }


  submitStepByStep(): void {
    if (this.cancel) {
      return;
    }
    this.clearClassAndCloseDialog(this.dialogRef, 'remove');
    this.actionDataService.delayOffer(this.leads[this.step], this.note, this.selectedDate)
      .subscribe(({ success, data }) => {
        if (this.leads.length - 1 === this.leads.lastIndexOf(this.leads[this.step])) {
          this.submitting = false;
        }

        this.step++;
        this.leadsMultipleStepByStepService.switchToNextStep();

        if (this.leads[this.step]) {
          this.submitStepByStep();
        }
      });
  }

  submit(): void {
    if (this.formIsValid) {
      this.submitting = true;

      if (this.isMany) {
        let action: any = {
          Name: 'MULTIPLE_LEADS_STEP_BY_STEP',
          Text: 'Bald geschafft...',
          leadsLength: this.leads.length,
          actionName: 'LEAD_REMINDER'
        }
        ActionHelper.doAction({} as any, action, this.dialog, this.leads, true)?.afterClosed().subscribe();
        this.submitStepByStep();
      } else {
        this.actionDataService.delayOffer(this.leadId, this.note, this.selectedDate)
          .subscribe(({ success, data }) => {
            if (success) {
              this.clearClassAndCloseDialog(this.dialogRef, 'remove');
            }

            this.submitting = false;
          });
      }
    }
  }
}
